<template>
    <div class="">
        <h5 class="info-head">银行信息<span v-if="!basicIsShow" style="margin-left:12px;color:red;font-weight:normal;">(存在入库审批中的专业类别,无法修改)</span><el-button v-if="basicIsShow" icon="el-icon-plus" @click="add">新增</el-button></h5>
        <table border strip class="info-table">
            <tr>
                <th>序号</th>
                <th><b>*</b>银行所在市</th>
                <th><b>*</b>银行开户名</th>
                <th><b>*</b>银行联行号</th>
                <th><b>*</b>开户行全称</th>
                <th><b>*</b>银行账号</th>
                <th v-if="accountSet == '1'">账户类型</th>
                <th>操作</th>
            </tr>
            <tr v-for="(a, i) in bankInfo" :key="i">
                <td>{{i+1}}</td>
                <td>{{a.address}}</td>
                <td>{{a.accountName}}</td>
                <td>{{a.relationNo}}</td>
                <td>{{a.name}}</td>
                <td>{{a.bankNo}}</td>
                <td v-if="accountSet == '1'">{{a.bankType}}</td>
                <td><a v-if="basicIsShow" @click.prevent="bankInfoEdit(i)" class="edit-btn">编辑</a>&nbsp&nbsp<a v-if="basicIsShow" @click.prevent="bankInfoRemove(i)" class="delete-btn">删除</a></td>
            </tr>
            <tr v-if="!bankInfo.length"><td colspan=6>暂无数据</td></tr>
        </table>
        <div class="splitter"></div>
        <div class="text-center">
            <el-button v-if="basicIsShow" :disabled="isSubmit" type="primary" @click="submit">提交</el-button>
        </div>
        <el-dialog :title="isNaN(editIndex)?'新增银行信息':'编辑银行信息'" :visible.sync="bankInfoFormVisible">
        <el-form :model="bankTemp" label-width="120px" :rules="rules" ref="bankForm" class="supplier-form">
            <el-form-item label="银行所在市：" prop="address">
                <el-input type="text" v-model.trim="bankTemp.address" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="银行开户名：" prop="accountName">
                <el-input type="text" v-model.trim="bankTemp.accountName" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="银行联行号：" prop="relationNo">
                <el-input type="text" v-model.trim="bankTemp.relationNo" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="开户行全称：" prop="name">
                <el-input type="text" v-model.trim="bankTemp.name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="银行账号：" prop="bankNo">
                <el-input type="text" v-model.trim="bankTemp.bankNo" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="账号类型：" prop="bankType" v-if="accountSet == '1'">
                <el-select v-model="bankTemp.bankType" placeholder="选择银行类型">
                    <el-option label="专户" value="专户"></el-option>
                    <el-option label="一般户" value="一般户"></el-option>
                  </el-select>
            </el-form-item>
        </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="bankInfoFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="closeBankInfo">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script type="text/babel">
    import { mapGetters, mapActions, mapMutations } from 'vuex'
    import { ADD, EDIT_MANAGER, REMOVE_MANAGER } from '@/store/mutation-types'
    import { rulesBank } from '@/util/rules'
    import apis from '@/store/apis'

    export default {
        name: 'supplier-manager',
        data () {
            return {
                rules: rulesBank,
                bankInfoFormVisible: false,
                bankTemp: {
                    bankType: null
                },
                isSubmit:false,
                editIndex:void(0),
                accountSet: '0',
                basicIsShow: false
            }
        },
        computed:mapGetters(['bankInfo', 'basic']),
        methods: {
            ...mapActions(['addOrEditBankInfo', 'removeBankInfo', 'submitBankInfo', 'getBankInfoList']),
            add(){
                this.editIndex=void(0)
                this.bankInfoFormVisible = true
                this.$nextTick(()=>{
                    this.bankTemp = {
                        bankType: null
                    }
                    this.$refs.bankForm.resetFields()
                })
            },
            bankInfoEdit(i){
                this.editIndex = i
                this.bankTemp = Object.assign({}, this.bankInfo[i])
                this.bankInfoFormVisible = true
            },
            bankInfoRemove(i){
                this.$confirm('此操作将删除该条记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.removeBankInfo(i)
                    this.$message({
                        type: 'success',
                        message: '删除成功'
                    })
                }).catch((e) => {
                    console.log(e)
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
            },
            closeBankInfo(){
                this.$refs.bankForm.validate((valid) => {
                    if (valid) {

                        this.addOrEditBankInfo({bankInfo: this.bankTemp, editIndex: this.editIndex})
                        this.bankInfoFormVisible = false
                    } else {
                        console.log('error submit!!')
                    }
                })
            },
            submit(){
            	this.isSubmit=true;
                this.submitBankInfo().then((res) => {
                    if(res.data.result){
                        this.$confirm(res.data.message||'操作成功！', '', {
                            confirmButtonText: '确定',
                            showCancelButton: false,
                            showClose: false,
                            type: 'success',
                            center: true
                        }).then(() => {
                        	this.isSubmit=false;
                            window.location.reload()
                        },() => {
                        	this.isSubmit=false;
                            window.location.reload()
                        })
                        window.sessionStorage.setItem(this.$route.name,'saved')
                    }else{
                    	this.isSubmit=false;
                        this.$alert(res.data.message)
                    }
                }, err => {
                	this.isSubmit=false;
                    this.$alert(err)
                })
            },
            getAccountType () {
                this.$http.get(`rest/api/completeFourInfo/getAccountType?id=${encodeURIComponent(this.basic.id)}`).then((res)=>{
                    if (res.data.result) {
                        this.accountSet = res.data.value
                    }
		        })
            },
            checkStatus(){
                return apis.getLittleStatus(this.$root.stockId,this.hasLittleStatus012,this.hasLittleStatus3)
            }
        },
        created(){
            this.$root.loading = true
            Promise.all([this.getBankInfoList(),
                this.getAccountType()
            ]).then(r=>{
                this.$nextTick(function(){
                    this.$root.loading = false
                })
            }).catch(err=>this.$root.loading = false)

        },
        mounted(){
            this.basicIsShow = window.sessionStorage.getItem('basicIsShow')=='true'?true:false
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/dsp/supplier/BankInfo.vue